import { useGridApiRef } from '@mui/x-data-grid';
import { useContractsReport } from 'apps/app/src/hooks/requests/use-contracts-report';
import { useSearchWithSearchParams } from 'apps/app/src/hooks/use-search-with-search-params';
import { ReportHeader } from '../../reports-components/ReportHeader';
import { ReportTable } from '../../reports-components/ReportTable';
import { REPORT_TYPES } from '../../reports-page/reports-page-types/report-type';
import { ContractsReportTable } from './contracts-report-page-table/ContractsReportPageTable';

type ContractsReportContentProps = {   
  reportId?: string;
};

export const ContractsReportContent: React.FC<ContractsReportContentProps> = ({ reportId }) => {
  const { data: contractsReportData, isLoading } = useContractsReport(reportId);
  const [searchText, setSearchText] = useSearchWithSearchParams();
  const { report, creationDate } = contractsReportData;
  const apiRef = useGridApiRef();
    
  return (
    <>
      <ReportHeader
        reportData={report}
        creationDate={creationDate}
      />
      <ReportTable 
        title="Contracts Report"
        placeholder='Enter customer name...'
        exportCsvFileName='Contracts report'
        onSearch={(searchValue) => setSearchText(searchValue)}
        reportType={REPORT_TYPES.CONTRACTS}
        apiRef={apiRef}
      >
        <ContractsReportTable
          isLoading={isLoading}
          filter={searchText ?? undefined}
          apiRef={apiRef}
          rows={report}
        />
        
      </ReportTable>
    </>
  );
};